<script setup>
  import AppSidebar from "@/components/App/Sidebar/AppSidebar.vue";
  import { computed, ref } from "vue";
  import { Settings, LayoutTemplate } from "lucide-vue-next";
  import { useRoute } from "vue-router";
  import { storeToRefs } from "pinia";
  import { useSurveyStore } from "@stores/survey/survey.js";
  import { useReportsV2Store } from "@stores/survey/reportsV2/reportsV2.js";

  
  const surveyStore = useSurveyStore();
  const { token: surveyToken, canAnalyzeSurvey } = storeToRefs(surveyStore);
  const reportsStore = useReportsV2Store();
  const { currentReport } = storeToRefs(reportsStore);

  const reportToken = computed(() => currentReport.value?.token);
  const route = useRoute();

  const navigation = computed(() => [
    {
      title: "Create",
      isOpen: ref(true),
      items: [
        {
          title: "Setup",
          url: `/surveys/${surveyToken.value}/reports/${reportToken.value}/settings`,
          icon: Settings,
          isActive: route.name === "ReportV2Settings",
          if: canAnalyzeSurvey.value,
        },
        {
          title: "Slides",
          url: `/surveys/${surveyToken.value}/reports/${reportToken.value}/slides`,
          icon: LayoutTemplate,
          isActive: route.name === "ReportV2Slides",
          if: canAnalyzeSurvey.value,
        },
      ],
    },
  ]);
</script>

<template>
  <AppSidebar
    :navigation="navigation"
    :back="{ label: 'Reports', to: `/surveys/${surveyToken}/reports` }" />
</template>
